import { sendAnalyticsEvent, UnknownEvent } from '@faststore/sdk'
import { useRef } from 'react'
import { XCloseGlobal } from 'src/components/icons/XCloseGlobal'
import { useGlobalNavigation } from 'src/contexts/global-navigation-context'
import { useMenu } from 'src/contexts/menu-context'
import { useOnClickAway } from 'src/sdk/ui/useOnClickAway'
import { LEVELS } from '../constants'
import { FirstLevel } from './FirstLevel'
import { FourthLevel } from './FourthLevel'
import { SecondLevel } from './SecondLevel'
import { ThirdLevel } from './ThirdLevel'

export const MenuDesktop = () => {
  const ref = useRef<HTMLDivElement>(null)

  const { state, dispatch } = useMenu()

  const { openCloseMenu, setOpenCloseMenu } = useGlobalNavigation()

  const handleClickCloseModal = () => {
    sendAnalyticsEvent<UnknownEvent>({
      name: 'menu_categorie',
      params: {
        path: '',
        section: 'hamb_menu',
        main_category: '',
      },
    })
    setOpenCloseMenu(false)
    dispatch({
      type: 'reset',
    })
  }

  useOnClickAway({
    isOpened: openCloseMenu,
    ref,
    callback: handleClickCloseModal,
  })

  return (
    <>
      <div
        className={`fixed top-0 left-0 transition-all h-screen w-auto z-[6] global-navigation-drawer global-navigation-desktop ${
          openCloseMenu ? 'open' : ''
        }`}
        ref={ref}
      >
        <div className="relative h-full w-full min-w-[360px] bg-white rounded-r-2xl">
          <button
            className="absolute right-6 top-10 block w-8 h-8 cursor-pointer z-[1] global-nav-close bg-white"
            onClick={() => handleClickCloseModal()}
            aria-label="Chiudi"
          >
            <XCloseGlobal />
          </button>
          <div className="w-full h-full flex flex-row rounded-tr-2xl overflow-hidden relative">
            {state.selectedLevel >= LEVELS.main && <FirstLevel />}
            {state.selectedLevel >= LEVELS.second_level && <SecondLevel />}
            {state.selectedLevel >= LEVELS.third_level && <ThirdLevel />}
            {state.selectedLevel === LEVELS.fourth_level && <FourthLevel />}
          </div>
        </div>
      </div>
      <div className="fixed top-0 left-0 transition-all h-screen w-screen bg-[rgba(0,0,0,.3)] z-[-1] opacity-0 global-nav-overlay"></div>
    </>
  )
}
